export const FONT_WEIGHT_OPTIONS = [
  { value: "400", label: "Regular" },
  { value: "700", label: "Bold" },
];

export const HEADING_TAG_OPTIONS = [
  { value: "h1", label: "H1", fontSize: 40 },
  { value: "h2", label: "H2", fontSize: 32 },
  { value: "h3", label: "H3", fontSize: 24 },
  { value: "h4", label: "H4", fontSize: 20 },
  { value: "h5", label: "H5", fontSize: 16 },
  { value: "h6", label: "H6", fontSize: 14 },
];

export const LINK_TARGET_OPTIONS = [
  { value: "_blank", label: "New window" },
  { value: "_self", label: "Same window" },
];

export const VOID_HTML_ELEMENTS = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr",
];

export const FONT_SIZE_RANGE = {
  min: 6,
  max: 80,
};

export const PAGE_WIDTH_RANGE = {
  min: 300,
  max: 1024,
};

export const IMAGE_WIDTH_RANGE = {
  min: 100,
  max: 1024,
};
